/**
 * Nomes de pessoa em Title Case ("MARIA DA SILVA" → "Maria da Silva"). O legado gravou muitos
 * cadastros em caixa alta; a exibição normaliza sem alterar o dado (quem edita e salva grava
 * o que está na tela). Conectivos ficam em minúsculas, exceto quando iniciam o nome.
 */
const NAME_CONNECTIVES = ['de', 'da', 'do', 'das', 'dos', 'e', 'di', 'du', 'del', 'della', 'van', 'von', 'y'];

export const titleCaseName = (name: string | null | undefined): string => {
  if (!name) return '';
  return name
    .trim()
    .toLocaleLowerCase('pt-BR')
    .split(/\s+/)
    .map((word, index) =>
      index > 0 && NAME_CONNECTIVES.includes(word)
        ? word
        : word.charAt(0).toLocaleUpperCase('pt-BR') + word.slice(1))
    .join(' ');
};
